export default __webpack_public_path__ + "static/media/lacerate.350481a3.png";